/** Where a popover sits relative to the control that opened it. */
export interface PanelPlacement {
  readonly left: number;
  readonly top?: number;
  readonly bottom?: number;
}

export interface Rect {
  readonly left: number;
  readonly top: number;
  readonly bottom: number;
}

export const PANEL_WIDTH = 320;
const EDGE = 8;
/** Below this, there is not enough room above the control to be worth opening into. */
const MIN_ROOM_ABOVE = 160;

/**
 * Anchored by its BOTTOM edge when it opens upwards, so the panel's height never has to be
 * known.
 *
 * Measuring the height was the obvious approach and it was wrong: on the FIRST open the
 * panel has not been laid out, so the height read as zero and the panel landed a screenful
 * too low — invisible, and only on the first click, which is the worst kind of bug to
 * notice. Anchoring by `bottom` removes the measurement from the problem entirely, which is
 * also why this function is pure and can be tested without a browser.
 */
export function placePanel(button: Rect, viewport: { width: number; height: number }): PanelPlacement {
  // Clamped horizontally: a panel that opens past the edge is a panel with items nobody
  // can reach.
  const left = Math.max(EDGE, Math.min(button.left, viewport.width - PANEL_WIDTH - EDGE));

  return button.top >= MIN_ROOM_ABOVE
    ? // Upwards by preference: the bell lives at the foot of the rail, and opening
      // downwards pushed the panel past the fold and added scroll to read it.
      { left, bottom: viewport.height - button.top + 4 }
    : // Downwards for the mobile header, where the bell is at the top of the screen.
      { left, top: button.bottom + 4 };
}
